import { render, staticRenderFns } from "./WinWithTable.vue?vue&type=template&id=140e2470&scoped=true"
import script from "./WinWithTable.vue?vue&type=script&lang=ts"
export * from "./WinWithTable.vue?vue&type=script&lang=ts"
import style0 from "./WinWithTable.vue?vue&type=style&index=0&id=140e2470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e2470",
  null
  
)

export default component.exports